import { DocumentData } from '../types/types';
import { apiResource } from '../../../common/services/apiClient';

export const documentsApi = apiResource<DocumentData>('documents');
